function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { usdToCents } from '@paperstac/helpers/lib/numberHelpers';
import React from 'react';
import Flex from '../Flex';
import Input from './Input';
import Prefix from './Prefix';
import { centsToUsd, formattedNumber, stripNonNumeric } from '@paperstac/helpers/lib/number';
const UsdInput = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    field,
    ...props
  } = _ref;
  const value = props.value || field.value;
  const name = props.name || field.name;
  const onChange = props.onChange || field.onChange;
  const [formatted, setFormatted] = React.useState(typeof value !== 'number' ? '' : formattedNumber(centsToUsd(value), true));
  const handleChange = React.useCallback(event => {
    const eventValue = event.target.value;
    const value = eventValue === '' ? '' : usdToCents(eventValue);
    const [number, decimal] = eventValue.split('.');
    const suffix = decimal ? ".".concat(decimal) : eventValue.charAt(eventValue.length - 1) === '.' ? '.' : '';
    setFormatted("".concat(formattedNumber(+stripNonNumeric(number))).concat(suffix));
    !!onChange && onChange({
      ...event,
      target: {
        ...event.target,
        name,
        value
      }
    });
  }, [name, onChange]);
  React.useEffect(() => {
    if (value === '') {
      setFormatted('');
    } else if (!isNaN(value) && value !== usdToCents(formatted)) {
      setFormatted(formattedNumber(centsToUsd(value), true));
    }
  }, [formatted, value]);
  return /*#__PURE__*/React.createElement(Flex, {
    ref: ref
  }, /*#__PURE__*/React.createElement(Prefix, {
    px: 3
  }, "$"), /*#__PURE__*/React.createElement(Input, _extends({}, field, props, {
    value: formatted,
    onChange: handleChange,
    inputMode: "decimal",
    hasPrefix: true
  })));
});
UsdInput.propTypes = {};
UsdInput.defaultProps = {};
UsdInput.displayName = 'UsdInput';
export default UsdInput;